import React, { Fragment } from 'react';
import { oneOfType, bool, object, number } from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import PdpSharedDealerDistinctions from '../PdpSharedDealerDistinctions/PdpSharedDealerDistinctions';
import PdpSharedDealerInfo from '../PdpSharedDealerInfo/PdpSharedDealerInfo';
import PdpRespDealerDetailsFeedbackStat from './PdpRespDealerDetailsFeedbackStat/PdpRespDealerDetailsFeedbackStat';

import styles from './PdpRespDealerDetailsStats.scss';

function PdpRespDealerDetailsStats(props) {
    const { showOrderFeedback, reviews, seller, user, showDescriptions } = props;
    const canShowSellerName = get(user, 'canShowSellerName');
    let detailsHeader;

    let feedbackRating = get(reviews, 'metadata.aggregatedFeedback.overallExperience.mean');
    feedbackRating = feedbackRating ? parseFloat(feedbackRating.toFixed(1)) : 0;

    if (canShowSellerName) {
        detailsHeader = get(seller, 'sellerProfile.company');
    } else {
        detailsHeader = (
            <FormattedMessage
                id="PdpRespDealerDetailsStats.seller_title"
                defaultMessage="About the Seller"
            />
        );
    }

    return (
        <Fragment>
            <h2 className={styles.heading}>{detailsHeader}</h2>
            {showOrderFeedback && (
                <PdpRespDealerDetailsFeedbackStat feedbackRating={feedbackRating} />
            )}
            <PdpSharedDealerDistinctions seller={seller} showDescriptions={showDescriptions} />
            <div className={styles.companyInfo}>
                <PdpSharedDealerInfo seller={seller} />
            </div>
        </Fragment>
    );
}

PdpRespDealerDetailsStats.defaultProps = {
    showDescriptions: false,
};

PdpRespDealerDetailsStats.propTypes = {
    seller: object.isRequired,
    relay: object.isRequired,
    reviews: object,
    user: object,
    showDescriptions: bool,
    showOrderFeedback: bool,
};

export default createFragmentContainer(PdpRespDealerDetailsStats, {
    reviews: graphql`
        fragment PdpRespDealerDetailsStats_reviews on SellerOrderFeedbackPdpQueryConnection {
            metadata {
                aggregatedFeedback {
                    overallExperience {
                        mean
                    }
                }
            }
        }
    `,
    seller: graphql`
        fragment PdpRespDealerDetailsStats_seller on Seller {
            ...PdpSharedDealerDistinctions_seller
            ...PdpSharedDealerInfo_seller
            serviceId
            sellerProfile {
                company
            }
        }
    `,
    user: graphql`
        fragment PdpRespDealerDetailsStats_user on User {
            canShowSellerName
        }
    `,
});
